import { apiCall } from './generated/gqlClient';

export const getWorkoutDetailsApiRequest = async (id, userId, customer, groupId) => {
  const query = `
    query ${customer ? `getUserWorkoutDetails` : `getWorkoutDetails`}($id: String!, ${customer ? `` : `$userId: Int, $groupId: Int`}) {
      ${customer ? `getUserWorkoutDetails` : `getWorkoutDetails`}(id: $id, ${customer ? `` : `userId: $userId, groupId: $groupId`}) {
        id
        providerId
        title
        description
        level
        imageId
        thumbnailUrl
        price
        plan {
          id
          groupId
        }
        circuits {
          id
          workoutId
          circuitId
          userCircuitId
          isCircuit
          title
          description
          orderIndex
          type
          repetitions
          executionMode
          executionDisplayUnits
          executionMaxValue
          exercises {
            id
            workoutId
            exerciseId
            circuitId
            userCircuitId
            isCircuit
            title
            description
            orderIndex
            executionMode
            executionDisplayUnits
            restTime
            executionMinValue
            executionMaxValue
            type
            repetitions
            exercise {
              id
              providerId
              name
              description
              muscleArea
              level
              imageId
              videoId
              gifId
              muscleTargets
              gifThumbnailUrl
              imageThumbnailUrl
              videoThumbnailUrl
              equipments {
                id
                workoutCircuitId
                exerciseId
                equipmentId
                userWorkoutCircuitEquipmentId
                name
                type
                quantity
                weight
                settings
                weightMode
                isDefault
              }
            }
          }
        }
      }
    }
  `;
  return apiCall({ query, variables: customer ? { id } : { id, userId, groupId } });
};

export const getProviderUsersWorkoutPlansApiRequest = async () => {
  const query = `
    query getProviderUsersWorkoutPlans {
      getProviderUsersWorkoutPlans {
        id
        startTime
        endTime
        numberOfWeeks
        price
        active
        userId
        planId
        planTitle
        planPrice
        planNumberOfWeeks
        planSchedules {
          id
          title
        }
        planGroup {
          id
          color
        }
        user {
          id
          name
          describedName
          email
          firstname
          svcGroupId
          groups {
            id
            name
            color
          }
        }
        group {
          id
          name
          color
          type
        }
      }
    }
  `;
  return apiCall({ query });
};

export const getAllUserWorkoutPlansApiRequest = async userId => {
  const query = `
    query getAllUserWorkoutPlans($userId: Int!) {
      getAllUserWorkoutPlans(userId: $userId) {
        id
        startTime
        endTime
        numberOfWeeks
        price
        active
        userId
        plan {
          id
          providerId
          title
          description
          thumbnailUrl
          dateCreated
          price
          numberOfWeeks
          public
          planSchedules {
            id
            title
            description
            price
            workoutPlanTemplateId
            workoutId
            workoutTimeFrom
            workoutTimeTo
            workoutWeekdays
            circuits {
              id
              workoutId
              circuitId
              isCircuit
              title
              description
              orderIndex
              type
              repetitions
            }
          }
        }
        user {
          id
          name
          email
          firstname
        }
      }
    }
  `;
  return apiCall({ query, variables: { userId: +userId } });
};

export const getUserWorkoutPlanDetailsApiRequest = async (workoutPlanId, userId, groupId) => {
  const query = `
    query getUserWorkoutPlanDetails($workoutPlanId: String!, $userId: Int, $groupId: Int) {
      getUserWorkoutPlanDetails(workoutPlanId: $workoutPlanId, userId: $userId, groupId: $groupId) {
        id
        startTime
        endTime
        numberOfWeeks
        currentPlanNumberOfWeeks
        price
        active
        userId
        groupId
        providerId
        title
        description
        dateCreated
        public
        planSchedules {
          id
          title
          description
          price
          userId
          groupId
          workoutPlanTemplateId
          workoutId
          workoutTimeFrom
          workoutTimeTo
          workoutWeekdays
          workoutSchedule
          workoutOrder
          circuits {
            id
            workoutId
            circuitId
            userCircuitId
            isCircuit
            title
            description
            orderIndex
            type
            repetitions
          }
        }
      }
    }
  `;
  return apiCall({ query, variables: { workoutPlanId, userId, groupId } });
};

export const getUserWorkoutProgressDetailsByOwnerApiRequest = async (userId, userPlanId) => {
  const query = `
    query getUserWorkoutProgressDetailsByOwner($userId: Int!, $userPlanId: String!) {
      getUserWorkoutProgressDetailsByOwner(userId: $userId, userPlanId: $userPlanId) {
        progresses {
          id
          userId
          workoutId
          userPlanId
          dateCreated
          duration
          totalPercentage
          providerId
          note
          rating
          progress
          workoutTitle
        }
        workoutTitle
        planTitle
        userId
        user {
          id
          name
        }
      }
    }
  `;
  return apiCall({ query, variables: { userId: +userId, userPlanId } });
};

export const getUserWorkoutProgressDetailsByGroupApiRequest = async (groupId, groupPlanId) => {
  const query = `
    query getUserWorkoutProgressDetailsByGroup($groupId: Int!, $groupPlanId: String!) {
      getUserWorkoutProgressDetailsByGroup(groupId: $groupId, groupPlanId: $groupPlanId) {
        users {
          id
          email
          name
          activities {
            id
            userId
            workoutId
            userPlanId
            dateCreated
            duration
            totalPercentage
            providerId
            note
            rating
            progress
            workoutTitle
          }
        }
        planTitle
        groupName
        groupId
      }
    }
  `;
  return apiCall({ query, variables: { groupId: +groupId, groupPlanId } });
};

export const getAllUserWorkoutActivitiesApiRequest = async userId => {
  const query = `
    query getAllUserWorkoutActivities($userId: Int!) {
      getAllUserWorkoutActivities(userId: $userId) {
        id
        userId
        workoutId
        userPlanId
        dateCreated
        duration
        totalPercentage
        providerId
        progress
        note
        rating
        workoutTitle
        planTitle
        groupId
      }
    }
  `;
  return apiCall({ query, variables: { userId: +userId } });
};
